/* Lipscore-tilpasninger (OKH Media)

   1) Produktkort: fyller inn antall anmeldelser i .okh-ls-count etter at
      Lipscore har satt data-ls-product-votes pa stjerne-elementet.

   2) Produktside: viser antall + "Omtaler" som lenke ogsa nar produktet har
      stjernevurderinger men ingen skrevne omtaler. Lipscore lar da tallet i
      lenken sta tomt og skjuler den med .lipscore-hidden; riktig antall
      ligger i .lipscore-rating-votes. */
(function () {
  var scheduled = false;

  function setCardCount(starEl) {
    var votes = starEl.getAttribute('data-ls-product-votes');
    var wrap = starEl.parentElement;
    var countEl = wrap && wrap.querySelector('.okh-ls-count');
    if (countEl && votes && parseInt(votes, 10) > 0) {
      countEl.textContent = '(' + votes + ')';
    }
  }

  function fixProductRating(rating) {
    var link = rating.querySelector('.lipscore-rating-review-link');
    if (!link || link.dataset.okhDone === '1') return;

    var count = link.querySelector('.lipscore-rating-review-count');
    if (!count) return;

    if (count.textContent.trim() === '') {
      var votesEl = rating.querySelector('.lipscore-rating-votes');
      var votes = votesEl ? votesEl.textContent.trim() : '';
      if (!votes || parseInt(votes, 10) <= 0) return;
      count.textContent = votes;
    }

    link.classList.remove('lipscore-hidden');
    link.dataset.okhDone = '1';
  }

  function run() {
    scheduled = false;

    var stars = document.querySelectorAll('.lipscore-rating-small[data-ls-product-votes]');
    for (var i = 0; i < stars.length; i++) setCardCount(stars[i]);

    var ratings = document.querySelectorAll('.product__info-container .lipscore-rating');
    for (var j = 0; j < ratings.length; j++) fixProductRating(ratings[j]);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'data-ls-product-votes']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
  schedule();
})();